<div class="bg-m1 flex h-full cursor-default flex-col">
  <div class="flex h-2 flex-1 flex-row">
    <div class="mx-6 mt-8 flex min-w-[2px] flex-grow flex-col">
      <div class="flex h-11 flex-row items-center justify-between">
        <div class="flex w-full flex-row items-center">
          <div
            class="flex w-1/5 flex-shrink-0 flex-row items-center justify-between"
          >
            <div class="flex w-full flex-row items-center">
              <div
                data-cy="dashboardsTitle"
                class="text-s1 flex select-none items-center self-center text-2xl font-semibold"
                >{{ pageTitle }}
              </div>

              <m-left-panel-icon
                class="text-s500 ml-5 flex-shrink-0 cursor-pointer"
                (click)="toggleShowLeft()"
                [isFilled]="showDashboardsLeftPanel === true"
              ></m-left-panel-icon>

              <div
                class="ml-5 flex flex-shrink-0 cursor-pointer flex-row items-center"
                (click)="navToDashboardsList()"
              >
                <!-- <m-view-list-icon
                  [ngClass]="{
                    'text-m500': lastUrl === pathDashboardsList,
                    'text-s400': lastUrl !== pathDashboardsList
                  }"
                ></m-view-list-icon> -->

                <div
                  class="w-[34px] select-none items-center text-lg"
                  [ngClass]="{
                    'text-m500 font-semibold': lastUrl === pathDashboardsList,
                    'text-s500': lastUrl !== pathDashboardsList
                  }"
                >
                  List
                </div>
              </div>

              <div
                class="flex flex-1 flex-row items-center justify-center"
              ></div>

              <div
                [tp]="templateNewDashboard"
                [tpIsEnabled]="
                  alias === restrictedUserAlias || isExplorer === false
                "
                class="ml-5"
              >
                <button
                  type="button"
                  data-cy="dashboardsNewDashboardButton"
                  class="text-m0 h-11 flex-shrink-0 select-none rounded px-5 py-2 text-base font-medium focus:outline-none"
                  [ngClass]="{
                    'bg-m600':
                      alias !== restrictedUserAlias && isExplorer === true,
                    'bg-s400 cursor-default':
                      alias === restrictedUserAlias || isExplorer === false
                  }"
                  (click)="newDashboard()"
                  [disabled]="
                    alias === restrictedUserAlias || isExplorer === false
                  "
                  >New Dashboard</button
                >

                <ng-template #templateNewDashboard>
                  <div *ngIf="alias === restrictedUserAlias"
                    >Demo user is restricted</div
                  >

                  <div
                    *ngIf="
                      alias !== restrictedUserAlias && isExplorer === false
                    "
                    >Explorer role required</div
                  >
                </ng-template>
              </div>
            </div>
          </div>

          <div
            *ngIf="!!dashboard?.dashboardId"
            class="flex w-full flex-row items-center"
          >
            <!-- <div class="text-s1 ml-5 text-xl">{{
              (dashboard.title ? dashboard.title : dashboard.dashboardId)
                | capitalize
            }}</div> -->

            <ng-template #templateAddTile>
              <div *ngIf="alias === restrictedUserAlias"
                >Demo user is restricted</div
              >

              <div *ngIf="alias !== restrictedUserAlias && isExplorer === false"
                >Explorer role required</div
              >

              <div
                *ngIf="
                  alias !== restrictedUserAlias &&
                  isExplorer === true &&
                  dashboard.draft === true
                "
                >Save changes to be able to add tiles</div
              >

              <div
                *ngIf="
                  alias !== restrictedUserAlias &&
                  isExplorer === true &&
                  dashboard.draft === false &&
                  dashboard.canEditOrDeleteDashboard === false
                "
              >
                Only the dashboard author, project editors, and admins can edit
                this dashboard. Try editing the dashboard layout to create a
                draft, then save it as a new dashboard to become an author.</div
              >
            </ng-template>

            <div
              [tp]="templateAddTile"
              [tpIsEnabled]="
                isExplorer === false ||
                dashboard.draft === true ||
                dashboard.canEditOrDeleteDashboard === false
              "
              class="ml-[44px] flex h-11 flex-shrink-0"
            >
              <button
                type="button"
                data-cy="dashboardAddTileButton"
                class="flex-shrink-0 select-none rounded border px-5 py-2 text-base font-medium focus:outline-none"
                [ngClass]="{
                  'border-s400 text-s500 hover:bg-m0':
                    isExplorer === true &&
                    dashboard.draft === false &&
                    dashboard.canEditOrDeleteDashboard === true,
                  'border-s300 text-s400 cursor-default':
                    isExplorer === false ||
                    dashboard.draft === true ||
                    dashboard.canEditOrDeleteDashboard === false
                }"
                (click)="addTile()"
                [disabled]="
                  isExplorer === false ||
                  dashboard.draft === true ||
                  dashboard.canEditOrDeleteDashboard === false
                "
                >Add Tile</button
              >
            </div>

            <ng-template #templateEditListeners>
              <div *ngIf="dashboard.tiles.length === 0">No tiles</div>
              <div *ngIf="dashboard.fields.length === 0">No parameters</div>
            </ng-template>

            <div
              [tp]="templateEditListeners"
              [tpIsEnabled]="
                dashboard.tiles.length === 0 || dashboard.fields.length === 0
              "
              class="ml-5 h-11 flex-shrink-0"
            >
              <button
                type="button"
                data-cy="dashboardEditListenButton"
                class="flex h-11 select-none flex-row items-center rounded border px-4 py-2 text-base font-medium focus:outline-none"
                (click)="editListeners()"
                [ngClass]="{
                  'border-s400 text-s500 hover:bg-m0':
                    dashboard.tiles.length > 0 && dashboard.fields.length > 0,
                  'border-s300 text-s400 cursor-default':
                    dashboard.tiles.length === 0 ||
                    dashboard.fields.length === 0
                }"
                [disabled]="
                  dashboard.tiles.length === 0 || dashboard.fields.length === 0
                "
              >
                <m-link-icon
                  class="text-s500"
                  [ngClass]="{
                    'text-s500':
                      dashboard.tiles.length > 0 && dashboard.fields.length > 0,
                    'text-s400':
                      dashboard.tiles.length === 0 ||
                      dashboard.fields.length === 0
                  }"
                ></m-link-icon>

                <div class="ml-3"> Listeners </div>
              </button>
            </div>

            <div
              class="ml-10 flex cursor-pointer flex-row items-center"
              (click)="toggleShowTileParameters()"
            >
              <ui-switch
                class="mt-1"
                [checked]="showTileParameters"
                color="#64BD63"
              ></ui-switch>

              <div
                class="text-s1 ml-5 flex h-9 select-none items-center text-base"
                >Show Tile Parameters</div
              >
            </div>

            <div class="flex-grow"></div>

            <div class="flex flex-row justify-end">
              <div
                *ngIf="!!lastCompletedQuery"
                class="flex flex-row items-center justify-end"
              >
                <m-query-status
                  [query]="lastCompletedQuery"
                  [showDataRowsLength]="false"
                  [showLastCompleteDuration]="false"
                  [completedWord]="'Completed'"
                ></m-query-status>
              </div>

              <div class="flex flex-shrink-0 select-none flex-row items-center">
                <!-- <ng-template #templateDashboardSaveAs>
                <div *ngIf="isExplorer === false">Explorer role required</div>

                <div
                  *ngIf="isExplorer === true && alias === restrictedUserAlias"
                  >Demo user is restricted. Sign Up at https://mprove.io to get full
                  access.</div
                >
              </ng-template> -->

                <!-- <div
                class="ml-5 flex h-12 flex-shrink-0"
                [tp]="templateDashboardSaveAs"
                [tpIsEnabled]="
                  isExplorer === false || alias === restrictedUserAlias
                "
              >
                <button
                  type="button"
                  data-cy="dashboardSaveAsButton"
                  class="h-12 rounded border px-6 text-base font-medium focus:outline-none"
                  [ngClass]="{
                    'text-m0': dashboard.draft === true,
                    'bg-m500':
                      dashboard.draft === true &&
                      isExplorer === true &&
                      alias !== restrictedUserAlias,
                    'cursor-default bg-s400':
                      dashboard.draft === true &&
                      (isExplorer === false || alias === restrictedUserAlias),
                    ' border-s400 text-s500 hover:bg-m0':
                      dashboard.draft === false &&
                      isExplorer === true &&
                      alias !== restrictedUserAlias
                  }"
                  (click)="saveAs()"
                  [disabled]="
                    isExplorer === false || alias === restrictedUserAlias
                  "
                  >Save As</button
                >
              </div> -->

                <div
                  class="ml-7 flex cursor-pointer flex-row items-center"
                  (click)="toggleAutoRun()"
                >
                  <ui-switch
                    class="mt-1"
                    [checked]="isAutoRun"
                    color="#64BD63"
                  ></ui-switch>

                  <div
                    class="text-s1 ml-5 flex h-9 flex-shrink-0 select-none items-center text-base"
                    >Auto Run</div
                  >
                </div>

                <ng-template #templateAutoRunSelector>
                  <div *ngIf="alias === restrictedUserAlias"
                    >Demo user is restricted</div
                  >

                  <div
                    *ngIf="alias !== restrictedUserAlias && isAutoRun === false"
                    >Enable Auto Run to use selector</div
                  >
                </ng-template>

                <div
                  class="ml-5 flex flex-col items-stretch"
                  [tp]="templateAutoRunSelector"
                  [tpIsEnabled]="
                    alias === restrictedUserAlias || isAutoRun === false
                  "
                >
                  <div
                    *ngIf="
                      isAutoRun === true &&
                      alias !== restrictedUserAlias &&
                      refreshForm.controls['refresh'].value !== 0
                    "
                    class="h-[6px] w-full"
                  ></div>

                  <form [formGroup]="refreshForm">
                    <ng-select
                      #refreshSelect
                      [fixNgSelectBottom]="refreshSelect"
                      data-cy="refreshSelect"
                      class="popup-55 w-[100px] select-none"
                      [items]="refreshList"
                      [clearable]="false"
                      [searchable]="false"
                      (change)="refreshChange()"
                      (keyup.esc)="
                        $event.stopImmediatePropagation(); refreshSelect.blur()
                      "
                      (keyup.enter)="
                        $event.stopImmediatePropagation(); refreshSelect.blur()
                      "
                      appendTo="body"
                      bindLabel="label"
                      bindValue="value"
                      formControlName="refresh"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        <div class="ml-1 truncate">{{
                          alias !== restrictedUserAlias ? item.label : ''
                        }}</div>
                      </ng-template>

                      <ng-template ng-option-tmp let-item="item">
                        <div class="ml-1 truncate">{{ item.label }}</div>
                      </ng-template>
                    </ng-select>
                  </form>

                  <div
                    *ngIf="
                      isAutoRun === true &&
                      alias !== restrictedUserAlias &&
                      refreshForm.controls['refresh'].value !== 0
                    "
                    class="bg-s200 h-[6px] w-full overflow-hidden rounded-full"
                  >
                    <div
                      class="bg-g1 h-full transition-all duration-[50ms] ease-linear"
                      [style.width.%]="refreshProgress"
                    >
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  data-cy="dashboardRunButton"
                  class="text-m0 ml-6 mr-9 flex h-12 w-24 select-none items-center justify-center rounded text-base font-medium focus:outline-none"
                  [ngClass]="{
                    'bg-m600': dashboard.tiles.length > 0,
                    'cursor-default':
                      dashboard.tiles.length === 0 ||
                      isRunButtonPressed === true,
                    'bg-s400': dashboard.tiles.length === 0
                  }"
                  (click)="run()"
                  [disabled]="
                    dashboard.tiles.length === 0 || isRunButtonPressed === true
                  "
                >
                  <div *ngIf="isRunButtonPressed === false">Run</div>
                  <div
                    *ngIf="isRunButtonPressed === true"
                    class="relative flex h-9 w-9 flex-shrink-0"
                  >
                    <ngx-spinner
                      [name]="dashboardsRunButtonSpinnerName"
                      color="#FFFFFF"
                      bdColor="#00000000"
                      size="default"
                      type="ball-clip-rotate"
                      [fullScreen]="false"
                      [disableAnimation]="true"
                      [zIndex]="10"
                    >
                    </ngx-spinner>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6 flex h-2 flex-1 flex-row">
        <div
          class="mb-6 flex w-1/5 flex-shrink-0"
          *ngIf="showDashboardsLeftPanel === true"
        >
          <div class="flex w-full flex-col">
            <div class="bg-m0 flex w-full flex-grow rounded shadow">
              <div class="text-s1 mt-6 flex w-full flex-col text-base">
                <div class="flex flex-1 flex-col">
                  <div class="mb-6 flex h-11 flex-row items-center">
                    <m-search-icon class="text-s1 ml-6"></m-search-icon>

                    <input
                      spellcheck="false"
                      autocomplete="off"
                      data-cy="dashboardsSearchInput"
                      class="form-input focus:border-m600 border-s400 ml-3 h-10 w-[225px] select-none rounded"
                      placeholder="Search Dashboards"
                      [ngClass]="{
                        'bg-p200': !!word
                      }"
                      [(ngModel)]="word"
                      (ngModelChange)="searchWordChange()"
                    />

                    <div class="h-9 w-9">
                      <m-delete-icon
                        *ngIf="!!word"
                        class="text-s1 ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                        [ngClass]="{
                          'bg-p200 hover:bg-p300 cursor-pointer': !!word
                        }"
                        (click)="resetSearch()"
                      ></m-delete-icon>
                    </div>

                    <div class="flex flex-grow"></div>

                    <button
                      *ngIf="
                        filteredDraftsLength > 0 &&
                        alias !== restrictedUserAlias
                      "
                      class="ml-3 mr-10 flex select-none flex-row items-center rounded border px-4 py-2 focus:outline-none"
                      [ngClass]="{
                        'border-s400 text-s500 hover:bg-s100':
                          filteredDraftsLength > 0,
                        'border-s300 text-s400 cursor-default':
                          filteredDraftsLength === 0
                      }"
                      [disabled]="filteredDraftsLength === 0"
                      (click)="deleteDrafts()"
                    >
                      <m-trash-icon></m-trash-icon>
                      <div class="ml-3">Drafts</div>
                    </button>
                  </div>

                  <div class="divide-s300 ml-6 mr-9 flex flex-col divide-y">
                    <div class="flex flex-row"></div>
                    <div class="flex flex-row"></div>
                  </div>

                  <div
                    #leftDashboardsContainer
                    class="flex h-2 flex-grow flex-col overflow-y-auto"
                    [ngClass]="{
                      visible: isInitialScrollCompleted === true,
                      invisible: isInitialScrollCompleted === false
                    }"
                  >
                    <ng-scrollbar
                      [orientation]="'vertical'"
                      [visibility]="'hover'"
                      [appearance]="'compact'"
                    >
                      <div class="h-[12px]"></div>

                      <div
                        *ngFor="
                          let dPart of dashboardUnitsFiltered;
                          let i = index
                        "
                        [attr.dashboardId]="dPart.dashboardId"
                      >
                        <div
                          *ngIf="filteredDraftsLength > 0 && i === 0"
                          class="mb-4 ml-[24px] mr-[36px] mt-4 flex select-none flex-row justify-start font-semibold"
                          [ngClass]="{
                            'text-s400': alias === restrictedUserAlias,
                            'text-s500': alias !== restrictedUserAlias
                          }"
                        >
                          {{
                            alias === restrictedUserAlias
                              ? 'Drafts are hidden for Demo User'
                              : 'Drafts'
                          }}
                        </div>

                        <div
                          *ngIf="
                            alias !== restrictedUserAlias &&
                            dPart.draft === true
                          "
                          class="hover:bg-m50 group ml-6 mr-5 flex h-11 flex-row items-center rounded pr-2 hover:cursor-pointer"
                          (click)="navToDashboard(dPart.dashboardId)"
                          [ngClass]="{
                            'bg-m50':
                              dPart.dashboardId === dashboard?.dashboardId,
                            'mt-4': i === 0,
                            'mb-5': i === filteredDraftsLength - 1
                          }"
                        >
                          <div class="ml-4 mr-3 flex h-2 items-center">
                            <div
                              *ngIf="
                                dPart.dashboardId === dashboard?.dashboardId
                              "
                              data-cy="dashboardsSelectedSymbol"
                              class="bg-m600 text-m0 h-9 w-[6px] focus:outline-none"
                            ></div>

                            <div
                              *ngIf="
                                dPart.dashboardId !== dashboard?.dashboardId
                              "
                              class="h-9 w-[6px]"
                            ></div>
                          </div>

                          <div
                            class="ml-1 select-none truncate"
                            [ngClass]="{
                              'text-m600 font-semibold':
                                dPart.dashboardId === dashboard?.dashboardId,
                              'text-s1':
                                dPart.dashboardId !== dashboard?.dashboardId
                            }"
                          >
                            {{ dPart.title | capitalize }}
                          </div>

                          <div class="flex flex-grow"></div>

                          <div
                            tp="Explorer role required"
                            [tpIsEnabled]="isExplorer === false"
                          >
                            <button
                              *ngIf="
                                dashboard?.draft === true &&
                                dPart.dashboardId === dashboard?.dashboardId
                              "
                              data-cy="dashboardsSaveDraftButton"
                              class="ml-3 flex h-11 items-center justify-center rounded focus:outline-none"
                              (click)="dashboardSaveAs($event)"
                              [disabled]="isExplorer === false"
                            >
                              <div
                                class="hover:bg-m200 flex h-9 w-9 flex-shrink-0 flex-row items-center justify-center rounded px-2"
                              >
                                <m-save-icon
                                  [ngClass]="{
                                    'text-s500': isExplorer === true,
                                    'text-s400': isExplorer === false
                                  }"
                                ></m-save-icon>
                              </div>
                            </button>
                          </div>

                          <button
                            *ngIf="
                              dashboard?.draft === true &&
                              dPart.dashboardId === dashboard?.dashboardId
                            "
                            data-cy="dashboardsDeleteDraftButton"
                            class="hover:bg-m200 text-s500 ml-3 flex h-9 flex-shrink-0 items-center justify-center rounded px-2 focus:outline-none"
                            (click)="deleteDraftDashboard($event, dPart)"
                          >
                            <m-trash-icon></m-trash-icon>
                          </button>
                        </div>
                      </div>

                      <div
                        class="mb-4 ml-[24px] mr-[36px] mt-4 flex select-none flex-row items-center justify-start"
                      >
                        <button
                          class="text-s500 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                          type="button"
                          tp="Fold"
                          (click)="collapseDashboardsTree()"
                        >
                          <m-folder-minus-icon></m-folder-minus-icon>
                        </button>

                        <div class="text-s500 ml-[12px] font-semibold"
                          >Saved Dashboards</div
                        >

                        <button
                          class="ml-4 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                          type="button"
                          (click)="
                            setFavoritesOnly({
                              event: $event,
                              favoritesOnly: !favoritesOnly
                            })
                          "
                          [ngClass]="{
                            'text-m500': favoritesOnly === true,
                            'text-s500': favoritesOnly === false
                          }"
                        >
                          <m-star-icon
                            [isFilled]="favoritesOnly === true"
                          ></m-star-icon>
                        </button>
                      </div>

                      <div
                        *ngIf="filteredDashboardNodes?.length > 0"
                        class="ml-6"
                      >
                        <tree-root
                          class="h-2 w-full select-none"
                          #dashboardsTree
                          [nodes]="filteredDashboardNodes"
                          [options]="treeOptions"
                        >
                          <ng-template #treeNodeTemplate let-node="node">
                            <div
                              *ngIf="node.data.type === 'spaceFolder'"
                              class="group/bar flex h-11 w-full select-none flex-row rounded pr-5 hover:cursor-pointer"
                              (click)="dashboardTreeNodeOnClick({ node: node })"
                            >
                              <div
                                class="hover:bg-m50 relative flex w-full flex-row items-center rounded pl-2"
                                [style.padding-left.px]="(node.level - 1) * 12"
                              >
                                <div
                                  class="ml-2 flex flex-shrink-0 flex-row space-x-1"
                                >
                                  <div
                                    class="h-6 w-6"
                                    *ngIf="node.hasChildren === false"
                                  ></div>

                                  <m-chevron-right-icon
                                    class="text-s500"
                                    *ngIf="!node.isExpanded && node.hasChildren"
                                  ></m-chevron-right-icon>

                                  <m-chevron-down-icon
                                    class="text-s500"
                                    *ngIf="node.isExpanded && node.hasChildren"
                                  ></m-chevron-down-icon>

                                  <m-folder-closed-icon
                                    class="text-m500"
                                    *ngIf="
                                      !node.isExpanded || !node.hasChildren
                                    "
                                  ></m-folder-closed-icon>

                                  <m-folder-open-icon
                                    class="text-m600"
                                    *ngIf="node.isExpanded && node.hasChildren"
                                  ></m-folder-open-icon>
                                </div>

                                <div
                                  class="ml-3 flex min-w-[2px] flex-1 truncate"
                                >
                                  <span
                                    class="text-s1 truncate text-base"
                                    [ngClass]="{
                                      'font-semibold':
                                        node.data.isSelectedAncestor === true
                                    }"
                                    >{{
                                      node.data.isSynthetic === true
                                        ? node.data.title
                                        : (node.data.title | capitalize)
                                    }}</span
                                  >
                                </div>

                                <div
                                  *ngIf="node.data.isSynthetic !== true"
                                  class="invisible ml-2 flex pr-2 group-hover/bar:visible"
                                >
                                  <m-space-options
                                    [spaceFolder]="node.data"
                                  ></m-space-options>
                                </div>
                              </div>
                            </div>

                            <div
                              *ngIf="node.data.type === 'spaceUnit'"
                              [attr.dashboardId]="node.data.unitId"
                              class="hover:bg-m50 group mr-5 flex h-11 flex-row items-center rounded pr-2 hover:cursor-pointer"
                              (click)="dashboardTreeNodeOnClick({ node: node })"
                              [style.padding-left.px]="(node.level - 1) * 12"
                              [ngClass]="{
                                'bg-m50':
                                  node.data.unitId === dashboard?.dashboardId
                              }"
                            >
                              <div class="ml-4 mr-3 flex h-2 items-center">
                                <div
                                  *ngIf="
                                    node.data.unitId === dashboard?.dashboardId
                                  "
                                  data-cy="dashboardsSelectedSymbol"
                                  class="bg-m600 text-m0 h-9 w-[6px] focus:outline-none"
                                ></div>

                                <div
                                  *ngIf="
                                    node.data.unitId !== dashboard?.dashboardId
                                  "
                                  class="h-9 w-[6px]"
                                ></div>
                              </div>

                              <div
                                class="ml-1 select-none truncate"
                                [ngClass]="{
                                  'text-m600 font-semibold':
                                    node.data.unitId === dashboard?.dashboardId,
                                  'text-s1':
                                    node.data.unitId !== dashboard?.dashboardId
                                }"
                              >
                                {{ node.data.title | capitalize }}
                              </div>

                              <div class="flex flex-grow"></div>

                              <button
                                class="ml-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none group-hover:visible"
                                type="button"
                                (click)="
                                  toggleFavoriteDashboard({
                                    event: $event,
                                    dashboardId: node.data.unitId
                                  })
                                "
                                [ngClass]="{
                                  'text-s300': node.data.isFavorite === true,
                                  'text-s400': node.data.isFavorite !== true
                                }"
                                [class.invisible]="
                                  favoritesOnly === true ||
                                  node.data.isFavorite !== true
                                "
                              >
                                <m-star-icon
                                  [isFilled]="node.data.isFavorite === true"
                                ></m-star-icon>
                              </button>

                              <div
                                class="invisible ml-2 flex group-hover:visible"
                              >
                                <m-dashboard-options
                                  [spaceUnit]="node.data"
                                  [isHoverM]="false"
                                ></m-dashboard-options>
                              </div>
                            </div>
                          </ng-template>
                        </tree-root>
                      </div>

                      <div
                        *ngIf="filteredDashboardNodes?.length === 0"
                        class="text-s1 flex select-none justify-center px-6 py-8 text-[17px]"
                      >
                        {{
                          !!word
                            ? 'Search results are empty'
                            : favoritesOnly === true
                              ? 'Favorites are empty'
                              : 'Dashboards are empty'
                        }}
                      </div>
                    </ng-scrollbar>
                  </div>

                  <div class="divide-s300 ml-6 mr-9 flex flex-col divide-y">
                    <div class="flex flex-row"></div>
                    <div class="flex flex-row"></div>
                  </div>

                  <div class="mb-5 mr-5 mt-5 flex h-11 flex-row items-center">
                    <div class="text-s1 ml-6 select-none text-base"
                      >Timezone</div
                    >

                    <div class="ml-5 flex max-w-[260px] flex-1">
                      <form
                        class="w-full"
                        [formGroup]="timezoneForm"
                        tp="Timezone change is not allowed"
                        [tpIsEnabled]="
                          timezoneForm.controls['timezone'].disabled === true
                        "
                      >
                        <ng-select
                          #metricsTimezoneSelect
                          [fixNgSelectBottom]="metricsTimezoneSelect"
                          data-cy="metricsTimezoneSelect"
                          class="w-full select-none text-base"
                          [items]="timezones"
                          [clearable]="false"
                          [searchable]="true"
                          [searchFn]="timezoneSearchFn"
                          (change)="timezoneChange()"
                          (keyup.esc)="
                            $event.stopImmediatePropagation();
                            metricsTimezoneSelect.blur()
                          "
                          (keyup.enter)="
                            $event.stopImmediatePropagation();
                            metricsTimezoneSelect.blur()
                          "
                          appendTo="body"
                          bindLabel="label"
                          bindValue="value"
                          formControlName="timezone"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            <div class="truncate">{{ item.label }}</div>
                          </ng-template>

                          <ng-template ng-option-tmp let-item="item">
                            <div class="truncate">{{ item.label }}</div>
                          </ng-template>
                        </ng-select>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex h-full flex-1 flex-col">
          <div
            class="flex h-full flex-grow"
            [ngClass]="{
              'ml-6': showDashboardsLeftPanel === true
            }"
          >
            <div
              class="text-s1 flex h-full w-full select-none items-center justify-center pb-[80px] text-xl"
              *ngIf="lastUrl === pathDashboards"
            >
              Select Dashboard
            </div>

            <div *ngIf="lastUrl !== pathDashboards" class="h-full w-full">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isAutoRun$ | async"></div>
      <div *ngIf="routerEvents$ | async"></div>
      <div *ngIf="showDashboardsLeftPanel$ | async"></div>
      <div *ngIf="showTileParameters$ | async"></div>
      <div *ngIf="dashboardUnits$ | async"></div>
      <div *ngIf="dashboard$ | async"></div>
      <div *ngIf="nav$ | async"></div>
      <div *ngIf="member$ | async"></div>
      <div *ngIf="struct$ | async"></div>
      <div *ngIf="isExplorer$ | async"></div>
      <div *ngIf="alias$ | async"></div>

      <!-- [ngClass]="{
  'h-1/2': screenAspectRatio >= 1.5,
  'h-2/5': screenAspectRatio >= 1.2 && screenAspectRatio < 1.5,
  'h-1/3': screenAspectRatio < 1.2
}" -->
    </div>
  </div></div
>
